import React, { useState, useEffect } from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Container,
  Button,
  Form,
  Input,
  FormGroup,
  Label,
  CardHeader,
  CardTitle,
  ButtonGroup,
  CardFooter,
} from "reactstrap";
import DateTime from 'react-datetime'
import ReactSelect from 'components/Form/Select/Select'
import AsyncSelect from 'react-select/async'
import rest from '../../lib/rest'
import rotas from '../../services/rotas'
import useToggle from "../../lib/useToggle"
import Loading from 'lib/loading'
import useForm from "../../lib/useForm"
import Grafico from 'components/Graficos/Graficos'
import './style.css'

const inicialForm = {
  filial_id       : [],
  filialSelect    : [],
  data_inicio     : '',
  data_final      : '',
  filtro          : '',
  selectFiltro    : [],
  tipoGrafico     : {id : 0, title : "Gráfico Estatística por CMV"}
}

const inicialTipoGrafico = [
  {id : 0, title : "Gráfico Estatística por CMV"},
  {id : 1, title : "Gráfico Estatística por Desconto"},
]

const listaGrafico = [
  {
    // fonte: '/webgestor/api/graficos/estatistica/cmv/',
    fonte: '/webgestor/api/graficos/graficoVendaCMV.php',
    title: 'Vendas Por CMV',
    color: 'text-blue'
  },{
    fonte: '/webgestor/api/graficos/estatistica/desconto/',
    title: 'Desconto',
    color: 'text-blue'
  }
]

const filtroTotalizado  = [
  {id:'categoria', title:'Categoria'},
  {id:'vendedor', title:'Vendedor'},
  {id:'tabloid', title:'Tabloid'}
]

const inicialDadosGrafico = {lojas:['nenhuma'], valores: ['0'], total: ['0']}

const GraficoEstatistica = () => {

  const [form, onChange, setForm, onChangeSelect, onChangeDate] = useForm(inicialForm)
  const [loading, setLoading]                                   = useState(true)
  const [tipoGrafico, setTipoGrafico]                           = useState('PizzaCard')
  const [listaTipoGrafico, setListaTipoGrafico]                 = useState(inicialTipoGrafico)
  const [grafico, setGrafico]                                   = useState(inicialForm)
  const [dadosGrafico, setDadosGrafico]                         = useState(inicialDadosGrafico)
  const [selectlojas, setSelectlojas]                           = useState(false)
  const [listaLoja, setListaLoja]                               = useState([])

  const buscaDados = () => {
    setLoading(true)
    const url = listaGrafico[form.tipoGrafico.id].fonte
    try{
      const retorno = rest.post(url, form)
      retorno.then(ret => {
        // console.log(ret)
        if (ret.success && ret.success == 'S' && ret.lista != ''){
          // console.log(ret.lista)
          setDadosGrafico(ret.lista)
        }else{
          setDadosGrafico(inicialDadosGrafico)
        }
        setLoading(false)
      })

    }catch(err){
      console.log(err)
    }
  }

  const listaLojas = () => {
    // let lista = [{id: 0, title: 'TODAS'}]
    let lista = []
    const url = rotas.lojas
    try{
      const retorno = rest.get(url)
      retorno.then(ret => {
        // console.log(ret)
        if (ret.success && ret.success == 'S' && ret.lista != ''){
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i] = {"id":ret.lista[i].filial_id, "title":ret.lista[i].fantasia}
          }
          setListaLoja(lista)
        }
      })
      return (true)
    }catch(err){
      console.log(err)
    }
  }

  const handleSubmit = (evt) => {
    evt.preventDefault()
    buscaDados()
    setGrafico(form)
  }

  const handleGrafico = (evt) => {
    let selectGrafico = evt.target.value;
  
    setTipoGrafico(selectGrafico);
    
  }

  useEffect(() => {
    buscaDados()
    listaLojas()
  }, [])

  useEffect(()=>{
    if(form.filialSelect === null){
      form.filial = []
    }
  },form.filialSelect)

  useEffect(()=>{
    if(form.tipoGrafico.id === 2){
      if(tipoGrafico === 'BarrasCard'){
        setTipoGrafico('BarrasQtde');
      }

      if(tipoGrafico === 'PizzaCard'){
        setTipoGrafico('PizzaQtde');
      }
    }
  },[tipoGrafico,form.tipoGrafico])

  return (
    <>
    <div className="content">
      <Container>
        <Row>
          <Col md="12" className="p-0">
            <Card>
              <CardHeader>
                <Row>
                  <Col>
                    <CardTitle>GRÁFICO DE ESTATÍSTICA</CardTitle>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                {/* painel do filtro */}
                <div className="border p-3">
                  <Form onSubmit={handleSubmit}>
                    <Container>
                      <Row>
                        <Col md='6'>
                          <FormGroup className="mb-0">
                            <ReactSelect
                              name        = "tipoGrafico"
                              placeholder = "Selecione o tipo do gráfico"
                              options       = {listaTipoGrafico}
                              defaultValue  = {form.tipoGrafico}
                              onChange      = {onChangeSelect('tipoGrafico')}
                            ></ReactSelect>
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup className="mb-0">
                            <DateTime
                              id            = "dataInicial"
                              name          = "dataInicial"
                              inputProps    = {{ placeholder: "Período Inicial" }}
                              closeOnSelect = {true}
                              dateFormat    = "DD/MM/YYYY"
                              timeFormat    = {false}
                              value         = {form.data_inicio}
                              onChange      = {onChangeDate('data_inicio')}
                            >
                            </DateTime>
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup className="mb-0">
                            <DateTime
                              id            = "dataFinal"
                              name          = "dataFinal"
                              inputProps    = {{ placeholder: "Período Final" }}
                              closeOnSelect = {true}
                              timeFormat    = {false}
                              dateFormat    = "DD/MM/YYYY"
                              value         = {form.data_final}
                              onChange      = {onChangeDate('data_final')}
                            >
                            </DateTime>
                          </FormGroup>
                        </Col>

                        <Col md="1" className="">
                          <Button
                            className = "w-100 m-0"
                            type      = "submit"
                            color     = "success"
                            style     = {{ padding: '6px' }}
                          >
                            <i className="nc-icon nc-zoom-split"
                              style = {{ fontSize: '25px' }}
                            >
                            </i>
                          </Button>
                        </Col>

                      </Row>

                      <Row className="mt-1">
                        <Col md='7'>
                          <FormGroup className="mb-0">
                            <ReactSelect
                              multiple
                              isDisabled    = {selectlojas}
                              name          = "lojas"
                              placeholder   = "Selecione a loja"
                              options       = {listaLoja}
                              defaultValue  = {form.filialSelect}
                              onChange      = {onChangeSelect('filialSelect')}
                              onClick       = {form.filialSelect ? form.filial = form.filialSelect.map((x) => x.id) : ''}
                            ></ReactSelect>
                          </FormGroup>
                        </Col>

                        <Col md='4'>
                          <FormGroup className="mb-3">
                            {/* <Label for="filtroTotalizado">Selecione o agrupamento</Label> */}
                            <ReactSelect
                              name          = "filtroTotalizado"
                              placeholder   = "Selecione o agrupamento"
                              options       = {filtroTotalizado}
                              defaultValue  = {form.selectFiltro}
                              onChange      = {onChangeSelect('selectFiltro')}
                              onClick       = {form.selectFiltro ? form.filtro = form.selectFiltro.id : ''}
                            ></ReactSelect>
                          </FormGroup>
                        </Col>
                      </Row>

                    </Container>
                  </Form>
                </div>

                <Col md="12" className="p-0 mt-3 text-center">
                  <ButtonGroup aria-label="Tipos de Gráficos" onClick={handleGrafico} className="center">
                    <Button variant="secondary" value='PizzaCard' >Gráfico Pizza</Button>
                    {/* <Button variant="secondary" value='LinhaCard'>Gráfico Linha</Button> */}
                    <Button variant="secondary" value='BarrasCard'>Gráfico Barra</Button>
                  </ButtonGroup>
                </Col>

                <Col lg="12" sm="12" key={"col" + listaGrafico[grafico.tipoGrafico.id].title}>
                  <Grafico
                    // key       = {"grafico" + listaGrafico[form.tipoGrafico.id].title}graficografico
                    key       = {"grafico" + listaGrafico[grafico.tipoGrafico.id].title}
                    loading   = {loading}
                    // title     = {listaGrafico[form.tipoGrafico.id].title}
                    title     = {listaGrafico[grafico.tipoGrafico.id].title}
                    color     = 'text-blue'
                    lista     = {dadosGrafico}
                    component = {tipoGrafico}
                  />
                </Col>

              </CardBody>
              <CardFooter>
                <span style={{color:'#ff0000'}}>* Os totais podem variar entre os gráficos devido a arrendodamento de sistema.</span>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
    </>
  );
}

export default GraficoEstatistica;
